module.exports = __webpack_public_path__ + "static/media/joma.709a3365.png";